import { render, staticRenderFns } from "./custom-setPermission.vue?vue&type=template&id=17f7cad0&scoped=true&"
import script from "./custom-setPermission.vue?vue&type=script&lang=js&"
export * from "./custom-setPermission.vue?vue&type=script&lang=js&"
import style0 from "./custom-setPermission.vue?vue&type=style&index=0&id=17f7cad0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f7cad0",
  null
  
)

export default component.exports